import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import LoadingSpinner from '../loadingSpinner/';
import Results from './results';
import Filter from './filter';
import UnderHeader from "../underHeader";


@inject('resultStore', 'appStore')
@observer
export default class ResultContainer extends Component{
  componentDidMount() {
    this.props.resultStore.init(this.props.mode);
    const liveResults = this.props.resultStore.liveResults;
    liveResults.menu.subscribe(this.onupdate);
  }

  componentWillUnmount(){
    const liveResults = this.props.resultStore.liveResults;
    liveResults.menu.unsubscribe(this.onupdate);
  }

  onupdate = () => {
    this.setState({ upd: Date.now() });
  }

  // componentWillUnmount() {
  //   this.props.resultStore.reset();
  // }

  render() {

    const { cashboxId } =  this.props.appStore;
    this.props.resultStore.setCashboxModeId(cashboxId);
    const {isLoading} = this.props.resultStore;
    return(
      <Fragment>
        <div className="blue_line overflow">
          <UnderHeader type={2} />
        </div>
        {
          !isLoading ?
            <div className="result-index-loading">
              <LoadingSpinner />
            </div> :
            <Fragment>
              <Filter />
              <Results />
            </Fragment>
        }
      </Fragment>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/results/index.js